export default __webpack_public_path__ + "3bf90c9e257fce6d80ece0d72706d550.jpg";